import { render, staticRenderFns } from "./subject-list.vue?vue&type=template&id=487a1396&scoped=true&"
import script from "./subject-list.ts?vue&type=script&lang=ts&"
export * from "./subject-list.ts?vue&type=script&lang=ts&"
import style0 from "./subject-list.scss?vue&type=style&index=0&id=487a1396&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a1396",
  null
  
)

export default component.exports